<template>
  <v-row justify="center">
    <v-dialog
      v-model="curVisible"
      scrollable
      max-width="500px"
    >
      <v-card>
        <v-card-title>选择团队</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="min-height: 50px;margin: 0;padding: 0;">
          <div
            v-if="loading"
            style="text-align: center;
            height: 100px;
            line-height: 100px;">
            正在加载...
          </div>
          <div
            v-else-if="companyList && companyList.length === 0"
            style="text-align: center;
            height: 100px;
            line-height: 100px;">
            暂无团队
          </div>
          <v-list v-else style="padding: 0;">
            <v-list-item-group
              v-model="model"
              mandatory
              color="indigo"
              active-class="border"
            >
            <template v-for="(item, i) in companyList ">
              <v-divider v-if="i !== 0" :key="`divider-${i}`"></v-divider>
              <v-list-item
                :key="`item-${i}`"
                @click="changeCompany(item)"
              >
                <v-list-item-icon>
                  <v-icon v-if="item.type === 'ENT'">mdi-film</v-icon>
                  <v-icon v-else>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.label"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="model === i" color="success">mdi-check</v-icon>
                  <span v-else style="color: #9e9e9e">切换</span>
                </v-list-item-action>
              </v-list-item>
            </template>

            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
    // ,
    // companyCode: {
    //   type: String,
    //   default: ''
    // }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        var that = this
        that.$emit('update:visible', val)
        if (!val) {
          that.$emit('closed')
        }
      }
    }
  },
  data: () => ({
    model: 0,
    companyList: [],
    loading: true,
    companyCode: ''
  }),
  mounted() {
    var that = this
    that.initData()
  },
  methods: {
    async initData() {
      var that = this
      await that.$AppHelper.pullUserCustomData(function(data) {
        var cpy = data.staff_info;
        if (cpy && cpy.COMPANY_CODE) {
          that.companyCode = cpy.COMPANY_CODE;
        }
      });
      await that.getCompanyList();
      that.loading = false
    },
    async getCompanyList() {
      var that = this
      await that.$api.bz.getCompanyList().then(res => {
        if (!res.success) {
          // that.$toast.warning('获取团队列表失败');
          console.log('获取团队列表失败', res);
          return;
        }
        if (that.loading) {
          that.loading = false
        }
        var data = res.data
        if (data.length === 0) {
          return
        }
        that.companyList = []
        for (let index = 0; index < data.length; index++) {
          var item = data[index]
          if (item.COMPANY_CODE === that.companyCode) {
            that.model = index
          }
          that.companyList.push({ label: item.COMPANY_NAME, value: item.COMPANY_CODE, type: item.PARTY_TYPE })
        }
      })
    },
    async changeCompany(item) {
      var that = this
      if (that.companyCode === item.value) {
        that.curVisible = false
        return
      }
      var res = await that.$api.bz.toggleCompany({ code: item.value })
      // console.log('toggleCompany.res', res);
      if (!res.success) {
        that.$toast.warning('切换失败');
        return;
      }
      // that.$toast.success('切换成功');
      await that.$AppHelper.pullUserCustomData();
      await that.$AppHelper.pullNewUserToken();
      that.companyCode = item.value;
      that.companyToggled(item.value)
    },
    companyToggled(code) {
      var that = this
      that.curVisible = false
      that.$emit('company-toggled', code)
    }
  }
}
</script>
<style scoped>
/* .border {
  border: 2px dashed orange;
} */
</style>
